/**
 * @fileoverview added by tsickle
 * Generated from: components/loader/formio.loader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as ɵngcc0 from '@angular/core';
var FormioLoader = /** @class */ (function () {
    function FormioLoader() {
        this.loading$ = new BehaviorSubject(true);
        this.loading = true;
    }
    /**
     * @param {?} loading
     * @return {?}
     */
    FormioLoader.prototype.setLoading = /**
     * @param {?} loading
     * @return {?}
     */
    function (loading) {
        this.loading = loading;
        this.loading$.next(loading);
    };
FormioLoader.ɵfac = function FormioLoader_Factory(t) { return new (t || FormioLoader)(); };
FormioLoader.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FormioLoader, factory: function (t) { return FormioLoader.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormioLoader, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return FormioLoader;
}());
export { FormioLoader };
if (false) {
    /** @type {?} */
    FormioLoader.prototype.loading$;
    /** @type {?} */
    FormioLoader.prototype.loading;
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWlvLmxvYWRlci5qcyIsInNvdXJjZXMiOlsiZm9ybWlvLmxvYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7OztnREFHTTtBQUNOO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQGZpbGVvdmVydmlldyBhZGRlZCBieSB0c2lja2xlXG4gKiBHZW5lcmF0ZWQgZnJvbTogY29tcG9uZW50cy9sb2FkZXIvZm9ybWlvLmxvYWRlci50c1xuICogQHN1cHByZXNzIHtjaGVja1R5cGVzLGNvbnN0YW50UHJvcGVydHksZXh0cmFSZXF1aXJlLG1pc3NpbmdPdmVycmlkZSxtaXNzaW5nUmV0dXJuLHVudXNlZFByaXZhdGVNZW1iZXJzLHVzZWxlc3NDb2RlfSBjaGVja2VkIGJ5IHRzY1xuICovXG5pbXBvcnQgeyBJbmplY3RhYmxlIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG5pbXBvcnQgeyBCZWhhdmlvclN1YmplY3QgfSBmcm9tICdyeGpzJztcbnZhciBGb3JtaW9Mb2FkZXIgPSAvKiogQGNsYXNzICovIChmdW5jdGlvbiAoKSB7XG4gICAgZnVuY3Rpb24gRm9ybWlvTG9hZGVyKCkge1xuICAgICAgICB0aGlzLmxvYWRpbmckID0gbmV3IEJlaGF2aW9yU3ViamVjdCh0cnVlKTtcbiAgICAgICAgdGhpcy5sb2FkaW5nID0gdHJ1ZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQHBhcmFtIHs/fSBsb2FkaW5nXG4gICAgICogQHJldHVybiB7P31cbiAgICAgKi9cbiAgICBGb3JtaW9Mb2FkZXIucHJvdG90eXBlLnNldExvYWRpbmcgPSAvKipcbiAgICAgKiBAcGFyYW0gez99IGxvYWRpbmdcbiAgICAgKiBAcmV0dXJuIHs/fVxuICAgICAqL1xuICAgIGZ1bmN0aW9uIChsb2FkaW5nKSB7XG4gICAgICAgIHRoaXMubG9hZGluZyA9IGxvYWRpbmc7XG4gICAgICAgIHRoaXMubG9hZGluZyQubmV4dChsb2FkaW5nKTtcbiAgICB9O1xuICAgIEZvcm1pb0xvYWRlci5kZWNvcmF0b3JzID0gW1xuICAgICAgICB7IHR5cGU6IEluamVjdGFibGUgfSxcbiAgICBdO1xuICAgIHJldHVybiBGb3JtaW9Mb2FkZXI7XG59KCkpO1xuZXhwb3J0IHsgRm9ybWlvTG9hZGVyIH07XG5pZiAoZmFsc2UpIHtcbiAgICAvKiogQHR5cGUgez99ICovXG4gICAgRm9ybWlvTG9hZGVyLnByb3RvdHlwZS5sb2FkaW5nJDtcbiAgICAvKiogQHR5cGUgez99ICovXG4gICAgRm9ybWlvTG9hZGVyLnByb3RvdHlwZS5sb2FkaW5nO1xufVxuIl19